import React from "react";
import { Link } from "react-router-dom";
import { createFavoritePost, removeFavoritePost } from "../../../api";
import { formatToLocalDate } from "../../../utils";

class FavoriteCardItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post: this.props.post,
    };
  }

  setAsFavourite = () => {
    createFavoritePost(this.state.post.id);
    let p = this.state.post;
    p.isFavourite = !this.state.post.isFavourite;
    this.setState({
      post: p,
    });
  };

  removeAsFavorite = () => {
    removeFavoritePost(this.state.post.id);
    let p = this.state.post;
    p.isFavourite = !this.state.post.isFavourite;
    this.setState({
      post: p,
    });
  };

  render() {
    return (
      <div className="favorite-item">
        {!this.props.loggedIn && (
          <div class="rating" style={{ paddingRight: "8px", marginTop: "4px" }}>
            {this.state.post.isFavourite ? (
              <span className="selected" onClick={this.removeAsFavorite}>
                ★
              </span>
            ) : (
              <span onClick={this.setAsFavourite}>☆</span>
            )}
          </div>
        )}
        <div className="notif-content">
          <p className="notif-text">
            <Link to={`${this.state.post.url}`} className={"black"}>
              {this.state.post.title}
            </Link>
          </p>
          <div className="date-block">
            <span className="date">
              {formatToLocalDate(this.state.post.publishedAt)}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default FavoriteCardItem;
